import { createScanUiCloseTargetRegistry } from '../utils/createScanUiCloseTargetRegistry.util';

export const SCAN_UI_CLOSE_TARGET_REGISTRY = createScanUiCloseTargetRegistry();
